export const DATABASE_WORKSPACES_SETTING = "database-enable-workspaces";
